export default "__VITE_ASSET__BTdgbnuX__"